import { Checkbox, Dialog } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import "./TableFilterSort.scss";

const TableFilterSort = (props: any) => {
  const {
    selectedColumnData,
    setOpenTableFilterSort,
    openTableFilterSort,
    handleFilterAndSort,
    filter,
  } = props;
  interface FilterOption {
    selected: boolean;
    name: string;
  }

  const [localSortOrder, setLocalSortOrder] = useState(
    selectedColumnData.columnName === selectedColumnData.sortBy
      ? selectedColumnData.sortOrder
      : ""
  );
  const [selectedFilters, setSelectedFilters] = useState<{
    [key: string]: FilterOption;
  }>({});
  const handleCheckBox = (e: any, optionKey: any, optionName: any) => {
    const updatedSelection = { ...selectedFilters };
    updatedSelection[optionKey] = {
      selected: e.target.checked,
      name: optionName,
    };
    setSelectedFilters(updatedSelection);
  };

  const handleClearAll = () => {
    setSelectedFilters({});
  };

  const handleSave = () => {
    const controller: any = {};
    if (localSortOrder) {
      controller["sortBy"] = selectedColumnData.columnName;
      controller["sortOrder"] = localSortOrder;
    }
    const selectedItems = Object.entries(selectedFilters)
      .filter(([_, { selected }]) => selected)
      .map(([key, { name }]) => name);
    controller["selectedFilters"] = selectedItems;
    handleFilterAndSort(controller, false);
  };

  useEffect(() => {
    if (
      filter?.[selectedColumnData.columnName]?.length &&
      Object.keys(selectedColumnData?.filterOptions).length
    ) {
      const updatedSelection = { ...selectedFilters };
      Object.keys(selectedColumnData.filterOptions).forEach(
        (eachOptionKey: any, index: number) => {
          if (
            filter[selectedColumnData.columnName].findIndex(
              (eachSelectedOption: any) => eachSelectedOption === eachOptionKey
            ) > -1
          ) {
            updatedSelection[index] = {
              selected: true,
              name: eachOptionKey,
            };
          }
        }
      );
      setSelectedFilters(updatedSelection);
    }
  }, [filter]);
  const [position, setPosition] = useState({ top: 0, left: 0, show: false });
  useEffect(() => {
    let columnRef = document.getElementById(
      selectedColumnData.columnName + "-th"
    );
    if (columnRef) {
      let colBoundaries = columnRef.getBoundingClientRect();
      setPosition({
        top: colBoundaries.bottom + window.scrollY,
        left:
          colBoundaries.left +
          window.scrollX -
          (selectedColumnData.isLastColumn ? 60 : 0),
        show: true,
      });
    }
  }, [selectedColumnData]);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const filterSortElement = document.getElementsByClassName(
        "pw-filter-sort-width"
      )[0];
      if (
        filterSortElement &&
        !filterSortElement.contains(event.target as Node)
      ) {
        setOpenTableFilterSort(false);
      }
    };
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [setOpenTableFilterSort]);

  return (
    <Fragment>
      {openTableFilterSort && position.show ? (
        <div
          className="flex flex-col pw-filter-sort-width pw-filter-sort !bg-neutral-50"
          style={{
            position: "absolute",
            top: `${position.top}px`,
            left: `${position.left}px`,
          }}
        >
          <div className="pw-filter-sort-container">
            {selectedColumnData?.hasSortBy ? (
              <div className="flex flex-col justify-start items-start w-full gap-y-3">
                <div
                  className={`w-40 h-11 p-3 rounded justify-start cursor-pointer items-end gap-2 inline-flex ${
                    localSortOrder === "ASC" && "bg-neutral-50"
                  }`}
                  onClick={() => {
                    setLocalSortOrder("ASC");
                  }}
                >
                  <img
                    src="assets/icons/sort-alphabetical-ascending.svg"
                    alt=""
                  />
                  <div className="w-28 h-5 text-neutral-800 text-sm font-normal font-['Proxima Nova'] leading-tight">
                    Sort A to Z
                  </div>
                </div>
                <div
                  className={`w-40 h-11 p-3 rounded justify-start cursor-pointer items-end gap-2 inline-flex ${
                    localSortOrder === "DESC" && "bg-black"
                  }`}
                  onClick={() => {
                    setLocalSortOrder("DESC");
                  }}
                >
                  <img
                    src="assets/icons/sort_alphabetical_descending.svg"
                    alt=""
                  />
                  <div className="w-28 h-5 text-neutral-800 text-sm font-normal font-['Proxima Nova'] leading-tight">
                    Sort Z to A
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {Object.keys(selectedColumnData?.filterOptions)?.length ? (
              <div className="flex justify-between items-center w-full">
                <div className="pw-filter-text">Filters</div>
                <div
                  onClick={handleClearAll}
                  className="cursor-pointer pw-clear-color"
                >
                  Clear all
                </div>
              </div>
            ) : (
              ""
            )}
            {Object.keys(selectedColumnData?.filterOptions)?.length ? (
              <div className="flex flex-col justify-start items-start w-full mt-8 gap-y-3 pw-filter-table ">
                {Object.keys(selectedColumnData?.filterOptions)?.map(
                  (each: any, index: any) => {
                    return (
                      <div
                        className="flex justify-start items-center gap-x-1"
                        key={index}
                      >
                        <div>
                          <Checkbox
                            onClick={(e) => handleCheckBox(e, index, each)}
                            checked={
                              selectedFilters?.[index]?.selected || false
                            }
                          />
                        </div>
                        <div
                          className={`pw-status-option-btn font-bold pw-${each[0]?.toLowerCase()}-filter`}
                        >
                          {each}
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="flex pw-filter-buttons gap-x-3">
            <div
              onClick={() => setOpenTableFilterSort(false)}
              className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
            >
              Cancel
            </div>
            <div
              onClick={handleSave}
              className={`pw-bunit-button-primary  pw-bunit-button-save text-white
               ${"cursor-pointer bg-primary"}`}
            >
              Save
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default TableFilterSort;
